<template>
    <div class="admin__reports">
        <h5 class="admin__reports-title"><i class="far fa-file-chart-pie"></i> Generate Opt-Out Statistics</h5>
        <div class="row">
            <div class="col-xl-10">
                <p class="admin__reports-subtitle">Download a report csv file that provides all relevant Student Choice
                    Initiative statistics</p>
                <div class="row mb-3">
                    <div class="col-lg-5">
                        <label><i class="far fa-books"></i> Academic Year</label>
                    </div>
                    <div class="col-lg-7">
                        <div v-if="reportFlag" class="input-group input-group-sm">
                            <select class="form-control" id="academicYear" name="academicYear" ref="academicYear"
                                v-model="academicYear" @change="setReportLink(); setDateRange();">
                                <option v-if="!academicYear" value="" disabled>Select an academic year</option>
                                <option v-for="item in files" :value="item.yearStart" :key="item.file">{{ item.label }}
                                </option>
                            </select>
                        </div>
                        <div v-else class="text-primary">
                            <i class="far fa-bells"></i> There are currently no statistics reports that can be
                            generated. If there are
                            any questions or concerns, <b>please contact your system administrator.</b>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="academicYear">
                    <div class="col-lg-5">
                        <label><i class="far fa-calendar-alt"></i> Date</label>
                    </div>
                    <div class="col-lg-7">
                        <div class="input-group input-group-sm mb-3">
                            <select class="form-control" id="dateType" name="dateType" ref="dateType" v-model="dateType"
                                @change="setReportLink()">
                                <option v-if="!dateType" value="" disabled>Select a date type</option>
                                <option value="all">All Year</option>
                                <option value="range">Date Range</option>
                            </select>
                        </div>
                        <div class="admin__report-daterange" v-if="dateType ==='range'">
                            <div class="input-group input-group-sm mb-2">
                                <div class="input-group-prepend">
                                    <label class="input-group-text label__date" for="reportStartDate"> <i
                                            class="far fa-calendar-check mr-1"></i> Start Date</label>
                                </div>
                                <input type="date" class="form-control" id="reportStartDate" ref="reportStartDate"
                                    name="reportStartDate" :min="reportStartMin" :max="reportEndDate"
                                    v-model="reportStartDate" placeholder="Start Date" aria-label="Start date"
                                    @change="setReportLink()">
                                <small class="text-muted w-100">Date format: MM-DD-YYYY</small>
                            </div>
                            <div class="input-group input-group-sm">
                                <div class="input-group-prepend">
                                    <label class="input-group-text label__date" for="reportEndDate"> <i
                                            class="far fa-calendar-times mr-1"></i> End Date</label>
                                </div>
                                <input type="date" class="form-control" id="reportEndDate" ref="reportEndDate"
                                    name="reportEndDate" :min="reportStartDate" :max="reportEndMax"
                                    v-model="reportEndDate" placeholder="End Date" aria-label="End date"
                                    @change="setReportLink()">
                                <small class="text-muted w-100">Date format: MM-DD-YYYY</small>
                            </div>
                        </div>
                        <button v-if="!academicYear || !dateType || !reportLink" type="button"
                            class="btn btn-sm btn-secondary float-right" disabled>
                            <i class="far fa-download"></i>
                            Download
                        </button>
                        <a v-else :href="reportLink" class="btn btn-sm btn-primary float-right"><i
                                class="far fa-download"></i>
                            Download</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'admin-reports',
    props: {
        files: {
            type: Array
        }
    },
    data() {
        return {
            academicYear: '',
            dateType: '',
            reportEndDate: '',
            reportEndMax: '',
            reportStartDate: '',
            reportStartMin: '',
            reportLink: '',
            reportFlag: false
        }
    },
    methods: {
        hasStatistics() {
            if (this.files && this.files.length > 0) {
                this.reportFlag = true;
            } else {
                this.reportFlag = false;
            }
        },
        setDateRange() {
            if (this.academicYear) {
                var start = this.academicYear + '-05' + '-01';
                var end = parseInt(this.academicYear) + 1;
                end = end + '-04' + '-30';

                // Set start date
                this.reportStartDate = start;
                this.reportStartMin = start;

                // Set end date
                this.reportEndDate = end;
                this.reportEndMax = end;
            }
        },
        setReportLink() {
            let URL = 'https://HOSTNAME/cgi-bin/mkvn-sci-backend/controller.sci.pl?adminGenerateStats';
            URL = URL.replace("HOSTNAME", location.hostname);

            // Academic year
            if (this.academicYear) {
                URL = URL + '&academicYear=' + this.academicYear;
            }

            // Date type
            if (this.dateType.match(/all/i)) {
                URL = URL + '&type=all';
            } else if (this.dateType.match(/range/i)) {
                URL = URL + '&type=range';

                // Start date
                if (this.reportStartDate) {
                    URL = URL + '&startDate=' + this.reportStartDate;
                }

                // End date
                if (this.reportEndDate) {
                    URL = URL + '&endDate=' + this.reportEndDate;
                }
            }

            // Set report link
            this.reportLink = URL;
        }
    },
    mounted() {
        // Initial statistics file check
        this.hasStatistics();
    }
}
</script>

<style scoped>
.admin__reports {}

.admin__reports-title {
    color: #455a64;
    font-weight: 400;
}

.admin__reports-subtitle {
    font-weight: 300;
    margin-bottom: 15px;
    color: #99abb4;
}

.label__date {
    width: 112px;
}
</style>

